import { defineStore } from "pinia";
import { ref } from "vue";
import { GalaxyApi } from "@/api";
import {} from "@/api/invocations";
import { useKeyedCache } from "@/composables/keyedCache";
import { rethrowSimple } from "@/utils/simple-error";
export const useInvocationStore = defineStore("invocationStore", () => {
    const graphStepsByStoreId = ref({});
    async function fetchInvocationDetails(params) {
        const { data, error } = await GalaxyApi().GET("/api/invocations/{invocation_id}", {
            params: { path: { invocation_id: params.id } },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    }
    async function fetchInvocationJobsSummary(params) {
        const { data, error } = await GalaxyApi().GET("/api/invocations/{invocation_id}/jobs_summary", {
            params: { path: { invocation_id: params.id } },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    }
    async function fetchInvocationStep(params) {
        const { data, error } = await GalaxyApi().GET("/api/invocations/steps/{step_id}", {
            params: { path: { step_id: params.id } },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    }
    async function cancelWorkflowScheduling(invocationId) {
        const { data, error } = await GalaxyApi().DELETE("/api/invocations/{invocation_id}", {
            params: {
                path: { invocation_id: invocationId },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        storedInvocations.value[invocationId] = data;
        return data;
    }
    const { getItemById: getInvocationById, fetchItemById: fetchInvocationForId, storedItems: storedInvocations, } = useKeyedCache(fetchInvocationDetails);
    const { getItemById: getInvocationJobsSummaryById, fetchItemById: fetchInvocationJobsSummaryForId } = useKeyedCache(fetchInvocationJobsSummary);
    const { getItemById: getInvocationStepById, fetchItemById: fetchInvocationStepById } = useKeyedCache(fetchInvocationStep);
    return {
        getInvocationById,
        fetchInvocationForId,
        getInvocationJobsSummaryById,
        fetchInvocationJobsSummaryForId,
        getInvocationStepById,
        fetchInvocationStepById,
        cancelWorkflowScheduling,
        graphStepsByStoreId,
    };
});
